import axios from 'axios';

const base = () => `${window.store.event_backend_api}/communications/send`;

// The one call that actually reaches real policyholders — see
// AdHocController::store. Response carries the resolved recipient_count and
// the post-suppression sent_count, both shown to the caller after the send
// completes (never invented client-side).
export const sendAdHocMessage = (payload) =>
  axios.post(base(), payload).then(({ data }) => data.data);
